module.exports = __webpack_public_path__ + "./static/img/contact.4accba3711e82ef2ff038db7d843e9b4.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/contact.png
// module id = ./client/src/assets/fontawesome/contact.png
// module chunks = 0